// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7f58ece9"};